import { boxShadows, corners, media, typography } from "../../styles";
import styled, { css } from "styled-components";
import { applyOpacity } from "../../styles/utils";
import React from "react";
export type SelectableButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  selected?: boolean;
};
const unselectedStyles = css`
  background: ${({
  theme
}) => theme.colours.white};
  border: 2px solid ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.1)};
  color: ${({
  theme
}) => theme.colours.primaryText};
  @media ${media.hoverable} {
    &:hover {
      border-color: ${({
  theme
}) => theme.colours.primaryText};
    }
  }
`;
const selectedStyles = css`
  border: 2px solid
    ${({
  theme
}) => applyOpacity(theme.colours.primaryText, theme.colours.isDark.primaryForeground ? 1 : 0.8)};
  background: ${({
  theme
}) => applyOpacity(theme.colours.primaryText, theme.colours.isDark.primaryForeground ? 1 : 0.8)};
  color: ${({
  theme
}) => theme.colours.white};
  @media ${media.hoverable} {
    &:hover {
      border-color: ${({
  theme
}) => applyOpacity(theme.colours.primaryText, theme.colours.isDark.primaryForeground ? 1 : 0.8)};
    }
  }
`;

/**
 * Renders a button that can be selected. Behaviour is essentially the same as a
 * radio button, but styled as and used as a button. Usage examples include Date
 * selection in the CalendarDatePicker and Timeslot selection for the
 * Availability step.
 */
export const SelectableButton = styled.button<SelectableButtonProps>`
  ${typography.smallBold}
  ${corners.m}

  @media ${media.hoverable} {
    &:hover,
    &:active {
      cursor: pointer;
    }
  }

  &:focus {
    outline: none;
    background: ${({
  theme
}) => applyOpacity(theme.colours.primaryText, theme.colours.isDark.primaryForeground ? 0.1 : 0.05)};
    ${boxShadows.whiteInsetBorderShadow}
    color: ${({
  theme
}) => theme.colours.primaryText};
  }

  &:focus {
    border-color: ${({
  theme
}) => theme.colours.primaryText};
  }

  &:active {
    color: ${({
  theme
}) => applyOpacity(theme.colours.primaryText, theme.colours.isDark.primaryForeground ? 0.8 : 0.6)};
    border-color: ${({
  theme
}) => applyOpacity(theme.colours.primaryText, theme.colours.isDark.primaryForeground ? 0.9 : 0.6)};
  }

  ${({
  selected
}) => selected ? selectedStyles : unselectedStyles}
`;
export default SelectableButton;